 const columns = [
    {
        label: 'Photo',
        name: 'media',
        isImage: true
    },
    {
        label: 'Name',
        name: 'name'
    },
    {
        label: 'Description',
        name: 'description'
    },
    {
        label: 'Bedrooms',
        name: 'numberOfBedrooms'
    },
    {
        label: 'Bathrooms',
        name: 'numberOfBathrooms'
    },
    {
        label: 'Number Units',
        name: 'numberOfLabeledUnits'
    },
    {
        label: 'Occupied Units',
        name: 'occupiedUnits',
        isChip: true
    },
    {
        label: 'Vacant Units',
        name: 'vacantUnits',
        isChip: true
    },
    {
        label: 'Units under Maintenance',
        name: 'maintenceUnits',
        isChip: true
    },
    {
        label: 'BnBs',
        name: 'bnbs',
        isChip: true
    },
    {
        label: 'Price Per Month (Ksh)',
        name: 'pricePerMonth',
        isNumber:true
    },
    {
        label: 'Deposit (Ksh)',
        name: 'deposit',
        isNumber:true
    },
    {
        label: 'Expected Revenue (Ksh)',
        name: 'expectedRevenue',
        isNumber:true
    },
    {
        label: 'Revenue This Month (Ksh)',
        name: 'thisMonthRevenue',
        isNumber:true
    },
    {
        label: 'Last Payment',
        name: 'lastPaymentDate',
        isDate: true
    },
    {
        label: 'Action',
        name: 'action'
    }
]
export default columns
